export class CampaignsMetricsBuilder {
    constructor() {
        this.metrics = {};
    }

    setConversions(conversions) {
        this.metrics.conversions = conversions;
        return this;
    }

    setWinbackRevenue(winbackRevenue) {
        this.metrics.winbackRevenue = winbackRevenue;
        return this;
    }

    setAdditionalRevenue(additionalRevenue) {
        this.metrics.additionalRevenue = additionalRevenue;
        return this;
    }

    setLtvIncreaseRatio(ltvIncreaseRatio) {
        this.metrics.ltvIncreaseRatio = ltvIncreaseRatio;
        return this;
    }

    build() {
        return this.metrics;
    }
}
